import gql from 'graphql-tag';

export const CHANGE_STRIPE_SUBSCRIPTION_MUTATION = gql`
  mutation changeStripeSubscription($input: ChangeStripeSubscriptionInput!) {
    changeStripeSubscription(input: $input) {
      status
      errors {
        message
        type
      }
    }
  }
`;

export const GET_STRIPE_SUBSCRIPTIONS_QUERY = gql`
  query getStripeSubscriptions {
    stripeSubscriptions {
      id
      periodEnd
      periodStart
      status
    }
  }
`;
